import {configureStore} from '@reduxjs/toolkit';
import api from '../api/main/api';
import agreementReducer from '../features/agreement/agreementSlice';
import authReducer from '../features/auth/auth-slice';
import contactReducer from '../features/contact/slice';
import cartReducer from '../features/cart/cartSlice';
import fileReducer from '../features/file/fileSlice';
import navigationReducer from '../features/navigation/slice';
import messageReducer from '../features/message/messageSlice';
import tenantReducer from '../features/tenant/tenantSlice';
import userUpgradeReducer from '../features/upgrade_products/upgradeProductsSlice';
import userReducer from '../features/user/userSlice';
import viewingReducer from '../features/viewing/viewing-slice';
import withdrawReasonReducer from '../features/withdraw_reason/withdrawReasonSlice';
import requestDataReducer from '../features/requestdata/slice';
import resetReducer from '../features/reset/resetSlice';
import timerReducer from '../features/timer/timerSlice';
import registerReducer from '../features/register/registerSlice';
import loginSubscriber from './loginSubscriber';
import applicationReducer from '../features/application/slice';
import profileReducer from '../features/profile/slice';
import propertyReducer from '../features/property/slice';

const store = configureStore({
  reducer: {
    agreement: agreementReducer,
    application: applicationReducer,
    auth: authReducer,
    contact: contactReducer,
    file: fileReducer,
    navigation: navigationReducer,
    message: messageReducer,
    profile: profileReducer,
    property: propertyReducer,
    user: userReducer,
    tenant: tenantReducer,
    upgrade: userUpgradeReducer,
    cart: cartReducer,
    viewing: viewingReducer,
    withdrawReason: withdrawReasonReducer,
    requestData: requestDataReducer,
    reset: resetReducer,
    timer: timerReducer,
    register: registerReducer,
    [api.reducerPath]: api.reducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(api.middleware),
});

// Subscribe to login / logout
loginSubscriber(store);

export default store;
